import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=3aa61eba&scoped=true"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa61eba",
  null
  
)

export default component.exports